import {
  CaseSorting,
  CasesPredefinedFilterType,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { SortDirection } from '@avantstay/data-grid'
import { Defined } from '@avantstay/graphql-ts-client'

import { searchCases } from '@new/domains/operations/screens/CasesV2/service/cases'

export interface FiltersProps {
  label?: string
  isSidebarFilter?: boolean
  isInlineFilter?: boolean
  isAccordionOpen?: boolean
  showFilterAsColumn?: boolean
  disabled?: boolean
  onShowFilterAsColumn?: VoidFunction
}

/** A column filter that can also be driven from outside (side panel cache). */
export interface ColumnFilterProps extends FiltersProps {
  initialValue?: string[]
  onChange?: (value?: string[]) => void
}

export type SearchCaseValue = Defined<Awaited<ReturnType<typeof searchCases>>>['values'] &
  Pick<Defined<Awaited<ReturnType<typeof searchCases>>>, 'hasNextPage'>

export type SearchCaseRowProps = Defined<
  Awaited<ReturnType<typeof searchCases>>
>['values']['results'][0]

export enum RecurringTypes {
  recurring = 'RECURRING',
  notRecurring = 'NOT_RECURRIG',
}

export enum IsgiTypes {
  isgi = 'ISGI',
  notIsgi = 'NOT_ISGI',
}

export enum LogicalTypes {
  yes = 'yes',
  no = 'no',
}

export const logicalOptions = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
]

export enum QuickFilterOptions {
  all = 'all',
  overdue = 'overdue',
  assignedToMe = 'assignedToMe',
  createdByMe = 'createdByMe',
  createdByCleaner = 'createdByCleaner',
  closedLastDay = 'closedLastDay',
  closedLastThreeDays = 'closedLastThreeDays',
  closedLastWeek = 'closedLastWeek',
  closedLastTwoWeeks = 'closedLastTwoWeeks',
  closedLastMonth = 'closedLastMonth',
}

export interface SetQuickFilterProps {
  priorities?: string[]
  categories?: string[]
  types?: string[]
  status?: string[]
  dueDate?: string
  createdAt?: string
  sortBy?: CaseSorting
  sortOrder?: SortDirection
  quickFilterType?: CasesPredefinedFilterType
  quickFilterDate?: string
}
